"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var Window_styles_1 = require("./Window.styles");
var Window_classNames_1 = require("./Window.classNames");
var utilities_1 = require("@uifabric/utilities");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var WindowCloseAction = /** @class */ (function (_super) {
    __extends(WindowCloseAction, _super);
    function WindowCloseAction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onMouseDown = function (e) {
            e.stopPropagation();
        };
        _this._onClick = function (e) {
            e.stopPropagation();
            _this.props.window.close();
        };
        return _this;
    }
    WindowCloseAction.prototype.render = function () {
        if (this.props.window && !this.props.window.closeDisabled) {
            return (React.createElement("button", { type: "button", className: utilities_1.css(this.props.className, "close-action"), title: "Close " + (this.props.window.title || "App"), onClick: this._onClick, onMouseDown: this._onMouseDown },
                React.createElement(Icon_1.Icon, { className: "window-action-icon", iconName: "ChromeClose" })));
        }
        return null;
    };
    WindowCloseAction = __decorate([
        mobx_react_1.observer
    ], WindowCloseAction);
    return WindowCloseAction;
}(React.Component));
var Window = /** @class */ (function (_super) {
    __extends(Window, _super);
    function Window() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._canDrag = false;
        _this._onHeaderMouseDown = function (e) {
            _this._canDrag = true;
        };
        _this._onMouseUp = function (e) {
            _this._canDrag = false;
        };
        _this._onDragStart = function (e) {
            var db = _this.props.window.dashboard;
            if (db && _this._canDrag) {
                e.stopPropagation();
                var transferText = String(JSON.stringify(_this.props.window.config));
                e.dataTransfer.setData("text", transferText);
                window.setTimeout(function () {
                    db.setDrag(_this.props.window);
                }, 1);
            }
            else {
                e.preventDefault();
            }
        };
        _this._onDragEnd = function (e) {
            _this._canDrag = false;
            var db = _this.props.window.dashboard;
            if (db) {
                db.clearDrag();
            }
        };
        _this._onDragOver = function (e) {
            /*
            const db = this.props.grid.dashboard;
            const drag = db ? db.drag : undefined;
            if(drag) {
                e.stopPropagation();
                if(drag !== this.props.window) {
                    e.preventDefault();
                    try {
                        e.dataTransfer.dropEffect = "move";
                    } catch(ex) {}
                }
            }
            */
        };
        _this._onDrop = function (e) {
            /*
            e.stopPropagation();
            e.preventDefault();
            this._canDrag = false;
            this.props.grid.dropWindow(this.props.window);
            */
        };
        return _this;
    }
    Window.prototype._renderTitle = function () {
        return (React.createElement("div", { className: this._classNames.titleContainer },
            React.createElement("div", { className: this._classNames.title }, this.props.window.title)));
    };
    Window.prototype._renderActionBar = function () {
        return (React.createElement("div", { className: this._classNames.actionBar },
            React.createElement(WindowCloseAction, __assign({}, this.props, { className: utilities_1.css(this._classNames.action, "close-action") }))));
    };
    Window.prototype._renderHeader = function () {
        if (this.props.window.settings.headerHeight > 0) {
            return (React.createElement("div", { className: this._classNames.header, onMouseDown: this._onHeaderMouseDown, style: {
                    top: 0,
                    right: 0,
                    left: 0,
                    height: this.props.window.settings.headerHeight
                } },
                this._renderTitle(),
                this._renderActionBar()));
        }
        return null;
    };
    Window.prototype._renderBody = function () {
        return (React.createElement("div", { className: utilities_1.css(this._classNames.body, { "content-hidden": this.props.window.contentHidden }), style: {
                top: this.props.window.settings.headerHeight,
                right: 0,
                bottom: 0,
                left: 0
            } }, this.props.children));
    };
    Window.prototype.render = function () {
        var _a = this.props, window = _a.window, styles = _a.styles, className = _a.className;
        this._classNames = Window_classNames_1.getClassNames(Window_styles_1.getStyles(null, styles), className);
        return (React.createElement("div", { className: this._classNames.root, style: {
                borderWidth: window.settings.borderWidth
            }, onDragStart: this._onDragStart, onDragEnd: this._onDragEnd, onDragOver: this._onDragOver, onDrop: this._onDrop, draggable: true },
            this._renderHeader(),
            this._renderBody()));
    };
    Window = __decorate([
        mobx_react_1.observer
    ], Window);
    return Window;
}(React.Component));
exports.Window = Window;
